import React from "react"
import PropTypes from "prop-types"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { LinkContainer } from "react-router-bootstrap"
import { Grid, PageHeader, Table, Button, Glyphicon } from "react-bootstrap"
// import {Table, Column, Cell} from "fixed-data-table-2"
import { Map } from "immutable"

import * as actionCreators from "../actions"
import { ButtonAdd, getRecords } from "./Common"

class Dealers extends React.Component {
  static propTypes = {
    dealers: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
  }

  state = {}

  handleDelete = e => {
    e.preventDefault()
    
    const { id } = e.target
    if (window.confirm("Are you sure you want to delete this dealer?")) {
      this.props.actions.deleteDealer(id)
    }
  }

  render() {
    return (
      <Grid>
        <PageHeader>
          Dealers
          
          {/* <Button className="pull-right" bsSize="small" onClick={() => this.props.actions.refreshDealers()}>
            <Glyphicon glyph="refresh" />
          </Button> */}

          <span className="pull-right"><ButtonAdd to="/dealer/new" /></span>
        </PageHeader>

        <Table responsive fill striped>
          <thead>
            <tr>
              <th className="text-center">&nbsp;</th>
              <th className="text-center">Name</th>
              <th className="text-center">Address</th>
              <th className="text-center">Email</th>
              <th className="text-center">Phone</th>
              <th className="text-center">Contact Person</th>
            </tr>
          </thead>
          <tbody>
            { getRecords(this.props.dealers).map(o => (
              <LinkContainer key={o.get("uuid")} to={`/dealer/${o.get("uuid")}`}>
                <tr>
                  <td>
                    <Button bsSize="xsmall" bsStyle="danger" id={o.get("uuid")} onClick={this.handleDelete}>
                      <Glyphicon glyph="trash" id={o.get("uuid")} />
                    </Button>
                  </td>
                  <td>{o.get("dealerName")}</td>
                  <td style={{whiteSpace: "pre-wrap"}}>{o.get("dealerAddress")}</td>
                  <td>{o.get("dealerEmail")}</td>
                  <td>{o.get("dealerPhone1")}</td>
                  <td>{o.get("dealerContact")}</td>
                </tr>
              </LinkContainer>
            )) }
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="6">&nbsp;</td>
            </tr>
          </tfoot>
        </Table>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  dealers: state.get("dealers") || Map()
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actionCreators, dispatch)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dealers)



// WEBPACK FOOTER //
// ./src/components/Dealers.js